<template>
  <div :class="['player-bottom-contents', {'z-index-default' : isDefaultZIndex}]">
    <div class="player-nav" ref="nav">
      <ul>
        <li
          v-for="(tab, index) in tabs"
          :key="`bottom_tab_${index}`"
        >
          <button
            type="button"
            :class="{'on' : currentTab === tab.type}"
            @click.prevent="changeTab(tab)"
          >
            {{ tab.title }}
          </button>
        </li>
      </ul>
    </div>

<!--    에피소드 (vod) -->
    <EpisodeContentList
      v-if="currentTab === 'episode'"
      :content-info="contentInfo"
      :landing-info="landingInfo"
      :key="`vod-episode-list${componentKey}`"
    />

<!--    영화 시리즈 (movie) -->
    <MovieSeriesContentList
      v-else-if="currentTab === 'series'"
      :content-info="contentInfo"
      :key="`movie_series_${componentKey}`"
    />

<!--    관련 영상 (vod|movie) -->
    <RelatedContentList
      v-else-if="currentTab === 'related'"
      :section="section"
      :content-info="contentInfo"
      :landing-info="landingInfo"
      :key="`related_list_${componentKey}`"
    />

<!--    추천 (vod|movie) -->
    <template v-else-if="currentTab === 'recommend'">
      <VodMultiSections
        v-if="section === 'vod'"
        :content-info="contentInfo"
        :key="`vod-multi-section-list${componentKey}`"
      />

      <MovieMultiSections
        v-if="section === 'movie'"
        :content-info="contentInfo"
        :key="`movie-multi-section-list${componentKey}`"
      />
    </template>

<!--    상세 정보 (vod|movie) -->
    <ContentsDetail
      v-show="currentTab === 'detail'"
      :section="section"
      :content-info="contentInfo"
      :key="`${section}_detail_${componentKey}`"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import { MOVE_TO_DETAIL_TAB, DOWNLOAD_LAYOUT } from '@/common/resources/const'
import EpisodeContentList from '@/components/player/EpisodeContentList'
import RelatedContentList from '@/components/player/RelatedContentList'
import VodMultiSections from '@/components/player/VodMultiSections'
import ContentsDetail from '@/components/player/ContentsDetail'
import MovieSeriesContentList from '@/components/player/MovieSeriesContentList'
import MovieMultiSections from '@/components/player/MovieMultiSections'

export default {
  name: 'BottomTabContainer',
  components: {
    MovieMultiSections,
    EpisodeContentList,
    // VodAllList,
    MovieSeriesContentList,
    RelatedContentList,
    VodMultiSections,
    ContentsDetail
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => ({})
    },
    landingInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      section: '', // vod movie live -
      currentTab: '',
      componentKey: 0,
      tabs: [],
      isDefaultZIndex: false
    }
  },
  methods: {
    changeTab (tab) {
      this.currentTab = tab?.type || this.tabs[0]
      this.componentKey += 1
    },
    getTabTitle (tab) {
      const type = tab?.type || ''
      let title = ''
      switch (type) {
        case 'episode' :
          title = '에피소드'
          break
        case 'related' :
          title = '관련영상'
          break
        case 'recommend' :
          title = '추천'
          break
        case 'series' :
          title = '시리즈'
          break
        case 'detail' :
          title = '상세정보'
      }
      return title
    },
    moveToDetailTab () {
      this.changeTab(this.detailTab)

      const tab = this.$refs.nav
      const headerOffset = document.querySelector('header > .header-container')?.offsetHeight || 74
      const tabPosition = tab?.getBoundingClientRect().top
      const offsetPosition = tabPosition + window.pageYOffset - headerOffset
      window.scrollTo({
        top: offsetPosition
      })
    },
    getTabs () {
      let tabList = []
      switch (this.section) {
        case 'movie' :
          tabList = [ this.movieRelatedTab, this.seriesTab, this.recommendTab, this.detailTab ]
          break
        case 'vod' :
          tabList = [ ...this.landingTab, this.recommendTab, this.detailTab ]
          break
      }
      tabList = tabList.filter(item => item)
      tabList.map(tab => { Object.assign(tab, { title: this.getTabTitle(tab) }) })
      this.tabs = tabList
    }
  },
  computed: {
    recommendTab () {
      return { type: 'recommend' }
    },
    movieRelatedTab () {
      const { countinfo: countInfo = {} } = this.contentInfo
      const hasRelatedVideo = Number(_.get(countInfo, 'typeP', '0')) + Number(_.get(countInfo, 'typeA', '0')) > 0
      return hasRelatedVideo ? { type: 'related' } : null
    },
    seriesTab () {
      const { movieseriesid: movieSeriesId = '' } = this.contentInfo
      return movieSeriesId !== '' ? { type: 'series' } : null
    },
    detailTab () {
      return { type: 'detail' }
    },
    landingTab () {
      return _.get(this.landingInfo, 'landing_list.tab', [])
    }
  },
  created () {
    this.section = this.$route.meta?.section
    this.getTabs()
    this.$events.$on(DOWNLOAD_LAYOUT, (isOpen) => {
      this.isDefaultZIndex = isOpen
    })
  },
  mounted () {
    this.currentTab = _.get(this.tabs, '0.type', '')
    this.$events.$on(MOVE_TO_DETAIL_TAB, this.moveToDetailTab)
  },
  beforeDestroy () {
    this.$events.$off(MOVE_TO_DETAIL_TAB)
    this.$events.$off(DOWNLOAD_LAYOUT)
  }
}
</script>
